//** Manages loading state (spinners, etc) */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LoadingState {
  isLoading: boolean; // legacy simple loading flag
  globalBlocking: boolean; // true when we want to gray out entire app (file upload / data_analysis prep)
  blockingMessage?: string; // optional status message
}

const initialState: LoadingState = {
  isLoading: false,
  globalBlocking: false,
  blockingMessage: undefined
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    showGlobalBlocking: (state, action: PayloadAction<string | undefined>) => {
      state.globalBlocking = true;
      state.blockingMessage = action.payload;
    },
    hideGlobalBlocking: (state) => {
      state.globalBlocking = false;
      state.blockingMessage = undefined;
    }
  },
});

export const { setLoading, showGlobalBlocking, hideGlobalBlocking } = loadingSlice.actions;
export default loadingSlice.reducer;